import { casinoStoreKeys } from '../casinoStoreConstants'
import { useSetCasinoData } from '../hooks'

export const useSetCasinoLogMxParameters = () => {
  const { setCasinoData } = useSetCasinoData()

  const setCasinoLogMxParameters = (casinoLogMxParam, casinoLogMxPrefixOverride) => {
    setCasinoData(
      {
        [casinoStoreKeys.casinoLogMxParam]: casinoLogMxParam,
        [casinoStoreKeys.casinoLogMxPrefixOverride]: casinoLogMxPrefixOverride || ''
      },
      'setCasinoLogMxParameters'
    )
  }

  return { setCasinoLogMxParameters }
}
